module.exports = __webpack_public_path__ + "static/media/suitability.bc2b90ce.svg";